
export function  centerRectInRect(src, dst) {
  return {
    top: (dst.height / 2) - (src.height / 2),
    left: (dst.width / 2) - (src.width / 2),
    right: 0,
    bottom: 0,
    width: src.width,
    height: src.height,
  }
}
export function constrainRectInRect(dst, src, scale = false) {
  src = _.pick(src, ['width','height']);
  if(!scale && src.width/dst.width <= 1 && src.height/dst.height <= 1) {
    return this.centerRectInRect(src, dst);
  }
  scale = Math.min(dst.width/src.width, dst.height/src.height);
  src.width *= scale;
  src.height *= scale;
  return this.centerRectInRect(src, dst);
}

export function rectDiff(src, dst) {
  return {
    x: dst.left - src.left,
    y: dst.top - src.top,
  }
}

export function gridPosition(x, y, cellWidth, cellHeight, gridWidth, gridHeight) {
  let column = Math.round(x / cellWidth) + 1; 
  let row = Math.round(y / cellHeight) + 1;
  let columnCount = Math.floor(gridWidth / cellWidth);
  let rowCount = Math.floor(gridHeight / cellHeight);
  row = Math.min(rowCount, Math.max(1, row));
  column = Math.min(columnCount, Math.max(1, column));
  return { row, column, rowCount, columnCount };
}

export function applyRectToElement(elm, rect) {
  elm.style.top = rect.top ? rect.top : undefined;
  elm.style.left = rect.left ? rect.left : undefined;
  elm.style.width = rect.width ? rect.width : undefined;
  elm.style.height = rect.height ? rect.height : undefined;
  return elm;
}
  